import { Component, h, Host, Prop, State } from '@stencil/core';
import { pathStore } from '@store/path-store';
import { isSameDomain, isTargetReward360Domain } from '@utils/utilities';
import { ExploreItem, ExploreSectionProps } from '../types';

@Component({
  tag: 'explore-sec',
  styleUrl: 'explore-sec.scss',
  shadow: true
})
export class ExploreSec {
  @Prop() data: ExploreSectionProps;
  @State() showRedirectPopup: boolean = false;
  @State() redirectPopupContentType: string;
  @State() redirectTargetUrl: string = '';

  handleRedirectProceed = () => {
    if (this.redirectTargetUrl) {
      window.location.href = this.redirectTargetUrl;
    }
  };

  handleRedirectClose = () => {
    this.showRedirectPopup = false;
  };

  onCardClick = (event: Event, item: ExploreItem) => {
    event.stopPropagation();
    event.preventDefault();

    const { redirectUrl, disclaimer_popup } = item;

    if (!redirectUrl) return;

    const isCrossOrigin = !isSameDomain(redirectUrl);
    const hasDisclaimer = !!disclaimer_popup?.slug;
    const isGoingToReward360 = isTargetReward360Domain(redirectUrl);
    // CASE 2: If same-origin but has disclaimer configured
    if (hasDisclaimer) {
      this.redirectPopupContentType = disclaimer_popup.slug;
      this.redirectTargetUrl = redirectUrl;
      this.showRedirectPopup = true;
      return;
    }

    // CASE 1: If cross-origin
    if (isCrossOrigin && isGoingToReward360) {
      this.redirectPopupContentType = disclaimer_popup?.slug ?? '';
      this.redirectTargetUrl = redirectUrl;
      this.showRedirectPopup = true;
      return;
    }

    // Otherwise, navigate directly
    window.location.href = redirectUrl;
  };
  render() {
    const assetPath = pathStore.assetPath;

    return (
      <Host>
        <slot>
          <div class="py-2">
            <div class="flex justify-between py-4 features-container px-4">
              <p class="text-base font-bold text-black leading-6">{this.data?.title}</p>
              {this.data.viewAllLink && (
                <a href={this.data?.viewAllLink}>
                  <img src={`${assetPath}images/icons/right_circle_arrow.svg`} alt={`${this.data?.title}`} height="16" />
                </a>
              )}
            </div>
            <div class="flex gap-10 features-scroll-wrapper pl-3">
              {this.data?.explore_items?.map((feature: ExploreItem) => (
                <div class="feature-item">
                  <a href={feature.redirectUrl} target="_blank" class="clickable flex flex-col items-center" onClick={e => this.onCardClick(e, feature)}>
                    <div class="icon-wrapper">
                      <img src={`${feature.Icon.url}`} alt={feature.title} class="icon" />
                    </div>
                    <p class="title">{feature.title}</p>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </slot>
      </Host>
    );
  }
}
